<section class="personal-thrift" >
    
    <section class="no-padding-top">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
                <div class="block">
                  <div class="title"><strong>Register Your Organization</strong></div>
                  <!-- <button type="submit" class="btn btn-secondary">Cancel</button> -->
                  <div class="block-body">
                    <form [formGroup]="userData" class="form-horizontal"  (ngSubmit)="update()">
                      <div class="form-group row">
                        <label class="col-sm-3 form-control-label">Organization Name</label>
                        <div class="col-sm-9">
                          <input type="text" 
                          class="form-control" 
                          formControlName="orgName"
                          id="orgName"
                          name="orgName"
                          placeholder="Give your organization a name" 
                          autocomplete="off" 
                          required>
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="form-group row">
                        <label class="col-sm-3 form-control-label">Organization Description</label>
                        <div class="col-sm-9">
                          <input type="text" 
                          class="form-control"
                          formControlName="orgDescription"
                          id="orgDescription"
                          name="orgDescription" 
                          placeholder="Tell us about your Organization" 
                          autocomplete="off" 
                          required>
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="form-group row">
                        <div class="col-sm-9 ml-auto">
                         
                          <button type="submit" [disabled]="userData.invalid" class="btn btn-primary">Create Organization</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
          </div>
        </div>
    </section>
</section>